import { Component, Input } from '@angular/core';
import { AmdocsUserService } from 'amdocs-auth-package';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {

  @Input() size: AvatarImgSize = AvatarImgSize.medium;
  @Input() userName: string = null;
  @Input() uuid: string = null;
  @Input() showShortName = false;
  public showDefaultImage = false;

  constructor(private userService: AmdocsUserService) {
  }

  get fullPath(): string {
    const uuid = this.uuid || this.userService.user?.userProfile?.uuid;
    return `${environment.imgUrl}/${uuid}?v=${environment.avatarsVersion}`;
  }

  get userShortName(): string {
    const userName = this.userName || this.userService.user.userProfile.name;
    return userName ? this.userService.getUserShortName(userName) : '';
  }

  get fontClass(): string {
    const defaultClass = `${this.size}`;
    switch (this.size) {
      case AvatarImgSize.small: return `${defaultClass} text-medium-normal`;
      case AvatarImgSize.medium: return `${defaultClass} label-h3`;
      case AvatarImgSize.big: return `${defaultClass} label-h02`;
    }
  }

}

export enum AvatarImgSize {
  small = 'small',
  medium = 'medium',
  big = 'big'
}
